import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '../styles.css'
import './index.css'
import App from './App.tsx'
import './appInsights'
import { consentManager } from './services/consentManager'

// Initialize consent manager (will check for existing consent)
// The consent manager will automatically initialize Clarity and Application Insights
// based on user consent
if (typeof window !== 'undefined') {
  (window as typeof window & { consentManager: typeof consentManager }).consentManager = consentManager; // Expose for debugging
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
